import { Component, Fragment } from 'react';
import cx from 'classnames';
import { Router, Link } from './../../configs/routes';
import styles from '../../styles/header.scss';
import { VARIANT_KEY, VARIANT_VALUES } from '../../constants/variantConstants';
import { handleTrack } from '../../utils/trackActions';

interface Props {
  isMobile?: boolean;
  hasUserInvested?: boolean;
}

class HeaderNav extends Component<Props> {
  public static handleClick(e: any) {
    const hrefHash = e.currentTarget.href;
    if (hrefHash.split(':')[0] !== 'tel') {
      e.preventDefault();
      if (hrefHash.split('#')[1] === 'request-callback') {
        HeaderNav.handleNavTrack(e, hrefHash, 'talk_to_us');
      }
      const el = document.getElementById(hrefHash.split('#')[1]);
      if (el) {
        window.scrollTo({
          top: window.pageYOffset + el.getBoundingClientRect().top - 60,
          behavior: 'smooth',
        });
        HeaderNav.handleNavTrack(e, hrefHash);
      } else {
        const path = `/save?${VARIANT_KEY}=${VARIANT_VALUES.B}#${hrefHash}`;
        HeaderNav.handleNavTrack(e, path);
        Router.push(path);
      }
    } else {
      HeaderNav.handleNavTrack(e, hrefHash, 'talk_to_us');
    }
  }

  public static handleNavTrack = (
    e: any,
    trackUrl: string,
    trackLabel?: string
  ) => {
    handleTrack({
      label: `navbar_button_${trackLabel}`,
      url: trackUrl,
      obj: e.target,
    });
  };

  public render() {
    return (
      <Fragment>
        <div className={cx(styles['header-nav'], 'text-right')}>
          <a
            onClick={e =>
              handleTrack({ label: 'navbar_button', obj: e.target })
            }
            href="/s/mutual-funds#intro"
            target={'_blank'}
            rel={'noopener'}
          >
            Learn to Invest
          </a>

          <span
            onClick={e =>
              handleTrack({
                label: 'navbar_button',
                url: '/save/search',
                obj: e.target,
              })
            }
          >
            <Link href="/save/search">Explore</Link>
          </span>
          <a href="#top-plans" onClick={HeaderNav.handleClick}>
            Top Plans
          </a>
          <a href="#top-funds" onClick={HeaderNav.handleClick}>
            Top Funds
          </a>
        </div>
      </Fragment>
    );
  }
}

export default HeaderNav;



// WEBPACK FOOTER //
// ./components/home/headerNav.tsx